export default "__VITE_ASSET__CByTjTbF__"